import {Pagination} from 'antd';
import {useIntl} from 'react-intl';
import {INDEX_PAGE_SIZE_OPTIONS} from 'src/shared/constants/AppConst';

interface PaginationProps {
  total?: number;
  pageSize?: number;
  currentPage?: number;
  showPageSizeOptions?: boolean;
  onChangePage?: Function;
}

const PaginationTable = (props: PaginationProps) => {
  const {messages} = useIntl();
  const {total, pageSize, currentPage, showPageSizeOptions, onChangePage} =
    props;

  return (
    <Pagination
      total={total}
      className='pagination-table'
      current={currentPage}
      pageSize={pageSize}
      pageSizeOptions={INDEX_PAGE_SIZE_OPTIONS}
      showSizeChanger={showPageSizeOptions ?? false}
      showTotal={(total: any, range: any) =>
        `${messages['table.pagination.showing'].toString()} ${
          range[0]
        } ${messages['table.pagination.to'].toString()} ${range[1]} ${messages[
          'table.pagination.of'
        ].toString()} ${total} ${messages[
          'table.pagination.entries'
        ].toString()}`
      }
      onChange={(page: any, pageSize: any) =>
        onChangePage && onChangePage({page, pageSize})
      }
    />
  );
};

export default PaginationTable;
